import { emptyCommodity } from '../../constants/empty-commodity';
import { CommodityEditorState } from './commodity-editor.state';
import { createReducer, on } from '@ngrx/store';
import {
    commodityEditorLoadComplete,
    commodityEditorLoadFailure,
    commodityEditorLoadRequest,
    commodityEditorNew, commodityEditorSaveFailure,
    commodityEditorSaveRequest, commodityEditorSaveSuccess, commodityEditorSetCommodity
} from './commodity-editor.actions';

const initialState: CommodityEditorState = {
    id: null,
    commodity: emptyCommodity,
    loading: false,
    saving: false
};

const reducer = createReducer(
    initialState,
    on(commodityEditorNew, () => (initialState)),
    on(commodityEditorLoadRequest, (state) => ({ ...state, loading: true })),
    on(commodityEditorLoadFailure, (state) => ({ ...state, loading: false })),
    on(commodityEditorLoadComplete, (state, { commodity }) => ({ ...state, commodity, loading: false, saving: false, id: commodity.id })),
    on(commodityEditorSaveRequest, (state) => ({ ...state, saving: true })),
    on(commodityEditorSaveSuccess, (state) => ({ ...state, saving: false })),
    on(commodityEditorSaveFailure, (state) => ({ ...state, saving: false })),
    on(commodityEditorSetCommodity, (state, { commodity }) => ({ ...state, commodity: { ...state.commodity, ...commodity } }))
);

export function commodityEditorReducer(state: CommodityEditorState | undefined, action: any): any {
    return reducer(state, action);
}
